import { FREIGHT_TYPE, PRODUCT_TYPES } from '@schuettflix/interfaces';
import { AdditionalPropertiesId } from '@/shared/models/ContextDataModel/interfaces/enums/additional-properties-schema-id.ts';

export function getSchemaId(productType: PRODUCT_TYPES, freightType?: FREIGHT_TYPE): AdditionalPropertiesId {
    const isWasteFreightType = freightType === 'HAZARDOUS_WASTE' || freightType === 'NON_HAZARDOUS_WASTE';

    if ((productType === 'TRANSPORT' || productType === 'CUSTOM_TRANSPORT') && !freightType) {
        throw new Error('Freight type is required for transport products');
    }

    switch (productType) {
        // =================================
        // Handled by custom-request-service
        // =================================
        // Materials
        case 'CUSTOM_BULK_MATERIAL':
        case 'CUSTOM_RECYCLED_BULK_MATERIAL':
        case 'CUSTOM_CONCRETE':
        case 'CUSTOM_ASPHALT': {
            return 'MANUAL_MATERIAL_V1';
        }
        // Waste
        case 'CUSTOM_HAZARDOUS_WASTE_DISPOSAL':
        case 'CUSTOM_HAZARDOUS_WASTE_RECYCLING':
        case 'CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL':
        case 'CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING': {
            return 'MANUAL_WASTE_MATERIAL_V1';
        }
        // Transports
        case 'CUSTOM_TRANSPORT': {
            if (isWasteFreightType) {
                return 'MANUAL_WASTE_TRANSPORT_V1';
            } else {
                return 'MANUAL_TRANSPORT_V2';
            }
        }
        // Material & Transport Services
        case 'CUSTOM_SERVICE':
        case 'CUSTOM_SERVICE_ANALYSIS':
        case 'CUSTOM_SERVICE_ACCOMPANYING_DOCUMENT':
        case 'CUSTOM_SERVICE_TRANSPORT':
        case 'CUSTOM_SERVICE_TOLL':
        case 'CUSTOM_SERVICE_WAITING_TIME': {
            return 'MANUAL_SERVICE_V1';
        }
        // ===================================
        // Handled by material-channel-service
        // ===================================
        // Materials
        case 'BULK_MATERIAL':
        case 'RECYCLED_BULK_MATERIAL': {
            return 'AUTOMATIC_MATERIAL_V1';
        }
        // Waste
        case 'HAZARDOUS_WASTE_DISPOSAL':
        case 'HAZARDOUS_WASTE_RECYCLING':
        case 'NON_HAZARDOUS_WASTE_DISPOSAL':
        case 'NON_HAZARDOUS_WASTE_RECYCLING': {
            return 'AUTOMATIC_WASTE_MATERIAL_V1';
        }
        // ============================
        // Handled by transport-service
        // ============================
        case 'TRANSPORT': {
            if (!isWasteFreightType) {
                return 'AUTOMATIC_TRANSPORT_V1';
            } else {
                if (freightType === 'HAZARDOUS_WASTE') {
                    return 'AUTOMATIC_HAZARDOUS_WASTE_TRANSPORT_V1';
                } else {
                    return 'AUTOMATIC_NON_HAZARDOUS_WASTE_TRANSPORT_V1';
                }
            }
        }
        case 'SERVICE_TOLL':
        case 'SERVICE_WEIGHING_NOTE':
        case 'SERVICE_ACCOMPANYING_DOCUMENT':
        case 'SERVICE_ENERGY_SURCHARGE': {
            return 'AUTOMATIC_SERVICE_V1';
        }
    }
}
